import store from '@/vuex/store';

const removeNode = el => {
    let parentNode = el.parentNode;
    if (
        el.children.length > 0 &&
        el.children[0].className.includes("el-switch")
    ) {
        el.parentNode.hasDeletedNode = true;
        let firstChild = el.children[0];
        el.removeChild(firstChild);
    } else {
        
        parentNode && !parentNode.hasDeletedNode && parentNode.removeChild(el);
    }
};



const nodeOperator = (el, binding) => {
    let permission = window.localStorage.getItem('permission');
        if(permission){
       var permissions=  permission.split(',');
        }else{
          return  removeNode(el) ;
        }
   // console.log(permission);
   // const permission =store.getters.permission ? store.getters.permission.split(","):'';
  // console.log(permission);
    if(permissions=='all'){
        return;
    }
    const { value } = binding;
    if (!value) {
        removeNode(el)
        return el
    }
    if (!permissions.includes(value)) {
        removeNode(el)
    }else{
    }

}

export default {
    inserted: function (el, binding) {
        nodeOperator(el, binding)
    }
}


// WEBPACK FOOTER //
// ./src/directives/js/permission.js